module.exports = __webpack_public_path__ + "static/img/pdf.41dbb10e.png";